import Radio from 'backbone.radio';
import SignupAccount from '@/models/v5/signup_account';
import PasswordResetView from '@/views/login_password_reset';

    var globalCh = Radio.channel('global');
    export default function reset_password(token) {
        var controller = globalCh.request('controller');
        var options = globalCh.request('app_options');
        if (options.theme && options.theme.app_title) {
            document.title = "Reset Password - " + options.theme.app_title;
        } else {
            document.title = "Reset Password - Electric Imp";
        }

        var app_layout = controller.ensure_login_layout();

        if (!token) {
            app_layout.showChildView('content', new PasswordResetView({
                invalidToken: true
            }));
            return;
        }

        var signup_account = new SignupAccount({ token: token });

        app_layout.showChildView('content', new PasswordResetView({
            model: signup_account
        }));
    }

